import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { AuthGate } from './AuthGate.js';
import { Inspector } from './Inspector.js';
import './theme.css';

// Register the PWA service worker (makes SOR installable; it caches no vault data).
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => { void navigator.serviceWorker.register('/sw.js').catch(() => { /* non-fatal */ }); });
}

// The inspector portal is public (token-gated) and must bypass the owner's
// login gate and app shell entirely.
const isInspector = window.location.pathname.startsWith('/i/');

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {isInspector ? (
      <Inspector />
    ) : (
      <BrowserRouter>
        <AuthGate>
          <App />
        </AuthGate>
      </BrowserRouter>
    )}
  </React.StrictMode>,
);
